export default __webpack_public_path__ + "static/media/111_desktop.79fff390.jpg";